import React from 'react';

const TermsAndPolicies = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mb-8">
        Last updated: January 30, 2026
      </p>

      <p className="mb-6">
        Sidharth Rathore operates this website and related services (the
        “Services”) to provide users with a curated experience. The Services
        are powered by Shopify. This Privacy Policy describes how we collect,
        use, and disclose your personal information when you access or use
        our Services.
      </p>

      <p className="mb-6">
        By accessing or using the Services, you acknowledge that you have
        read and understood this Privacy Policy.
      </p>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Personal Information We Collect
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Contact details such as name, address, phone number, and email</li>
        <li>Financial and payment information</li>
        <li>Account credentials and preferences</li>
        <li>Transaction and purchase history</li>
        <li>Communications with us</li>
        <li>Device, IP address, and usage information</li>
      </ul>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Sources of Personal Information
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Directly from you</li>
        <li>Automatically through cookies and similar technologies</li>
        <li>From service providers and partners</li>
        <li>From third parties where permitted by law</li>
      </ul>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        How We Use Your Personal Information
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Provide, maintain, and improve our Services</li>
        <li>Process payments and transactions</li>
        <li>Communicate with you and provide customer support</li>
        <li>Marketing and promotional communications</li>
        <li>Security, fraud prevention, and legal compliance</li>
      </ul>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Disclosure of Personal Information
      </h2>
      <p className="mb-4">
        We may share your personal information with service providers,
        business partners, affiliates, or legal authorities where required
        or permitted by law.
      </p>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Relationship with Shopify
      </h2>
      <p className="mb-4">
        Our Services are hosted by Shopify, which processes personal
        information to operate and improve the Services. Shopify may
        transfer data internationally in accordance with applicable laws.
      </p>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Children’s Data
      </h2>
      <p className="mb-4">
        The Services are not intended for children. We do not knowingly
        collect personal data from individuals under the age of majority.
      </p>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Data Security & Retention
      </h2>
      <p className="mb-4">
        While we take reasonable measures to protect your data, no system
        is completely secure. Personal information is retained only as
        long as necessary for legal and business purposes.
      </p>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Your Rights
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Right to access, correct, or delete your data</li>
        <li>Right to data portability</li>
        <li>Right to opt out of marketing communications</li>
      </ul>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Changes to This Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy periodically. Updates will be
        posted on this page with a revised “Last updated” date.
      </p>

      <h2 className="text-xl font-semibold mt-10 mb-3">
        Contact Us
      </h2>
      <p>
        Email: <a className="text-emerald-600 underline" href="mailto:legaladityasharma@gmail.com">
          advsidharthr@gmail.com
        </a>
        <br />
        Address: D 202, LAWYERS CHAMBER BLOCK KARKARDOOMA COURT COMPLEX DELHI-110032
      </p>
    </div>
  );
};

export default TermsAndPolicies;